import { render, staticRenderFns } from "./AgedDebtorsAnalysis.vue?vue&type=template&id=1dd1c031&"
import script from "./AgedDebtorsAnalysis.vue?vue&type=script&lang=js&"
export * from "./AgedDebtorsAnalysis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports